import apiService from './api';

/**
 * Client API — catalogue d'examens médicaux (analyses, radiographies, …).
 * Le paramètre `category` filtre côté serveur (ANALYSIS | RADIOGRAPHY | ULTRASOUND).
 */
const medicalExamCatalogService = {
  getCategories() {
    return apiService.get('/medical-exam-catalog/categories');
  },

  getExams(params = {}) {
    return apiService.get('/medical-exam-catalog', { params });
  },

  getExamById(id) {
    return apiService.get(`/medical-exam-catalog/${id}`);
  },

  createExam(payload) {
    return apiService.post('/medical-exam-catalog', payload);
  },

  updateExam(id, payload) {
    return apiService.put(`/medical-exam-catalog/${id}`, payload);
  },

  deleteExam(id) {
    return apiService.delete(`/medical-exam-catalog/${id}`);
  }
};

export default medicalExamCatalogService;
